export const seoKeywords = {
  name: 'keywords',
  content:
    'AWS Cloud Services, Cloud Development Services, AWS Services, AWS Lambda Services, DevOps Services, Infrastructure as a code, cloud app development',
};

export const awsSeo = {
  title: 'AWS Cloud Solutions Development Company | Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Rumble Fish software developers are experts in cloud development services and cloud infrastructure services. Our skilled DevOps engineers and Cloud architects will take your product to the next level.',
    },
  ],
};
